import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Box, Button, Typography } from "@mui/material";
import { savePromotionImage, promotionError } from "../../api/promotions";
import { baseUrl } from "../../../../shared/api/endpoints";

/** Artwork uploads independently while retaining unsaved commercial fields and the latest optimistic version. */
export default function PromotionArtworkEditor({ original, value, onSaved, onBusy, disabled = false, kind = "plans" }) {
  const token = useSelector((state) => state.user.token);
  const input = useRef(null), [busy, setBusy] = useState(false), [error, setError] = useState("");
  const key = kind === "plans" ? original?.defaultImageKey : original?.code;
  const source = value.imageFileId ? `${baseUrl.replace(/\/$/, "")}/public/downloadFileById/${value.imageFileId}?size=small`
    : key ? kind === "plans" ? `/images/promotion-plans/${key}.webp` : `/images/promotion-placements/${key}.svg` : "/images/icons/no-image.svg";
  async function upload(file) {
    if (!original || busy || disabled) return;
    if (file && (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type) || file.size > 8 * 1024 * 1024)) {
      setError("تصویر JPEG، PNG یا WebP با حجم حداکثر ۸ مگابایت انتخاب کنید."); return;
    }
    setBusy(true); onBusy(true); setError("");
    try { onSaved(await savePromotionImage(token, { ...original, version: value.version ?? original.version }, file, kind)); }
    catch (reason) { setError(promotionError(reason)); }
    finally { setBusy(false); onBusy(false); if (input.current) input.current.value = ""; }
  }
  return <Box className="flex flex-col gap-2">
    <Typography>{kind === "plans" ? "تصویر پلن" : "تصویر راهنمای جایگاه"}</Typography>
    {original ? <>
      <img src={source} alt={value.name || value.title || "تصویر راهنما"} width="160" height="160" style={{ objectFit: "contain", alignSelf: "center" }} />
      <Typography variant="caption">{value.imageFileId ? "تصویر اختصاصی ثبت‌شده" : key ? "تصویر پیش‌فرض" : "هنوز تصویر پیش‌فرض تعیین نشده است."}</Typography>
      <input ref={input} type="file" hidden accept="image/jpeg,image/png,image/webp" onChange={(event) => {
        if (event.target.files?.[0]) upload(event.target.files[0]);
      }} />
      <div className="flex gap-2">
        <Button type="button" variant="outlined" disabled={busy || disabled} onClick={() => input.current.click()}>{busy ? "در حال آپلود…" : "آپلود و ثبت تصویر"}</Button>
        <Button type="button" disabled={busy || disabled || !value.imageFileId} onClick={() => upload(null)}>بازگشت به تصویر پیش‌فرض</Button>
      </div>
      <Typography variant="caption">حداکثر ۸ مگابایت؛ تصویر به WebP با ابعاد ۵۱۲ × ۵۱۲ تبدیل می‌شود. ثبت تصویر مستقل از سایر فیلدهای فرم است.</Typography>
    </> : <Typography variant="caption">ابتدا پلن را ثبت کنید؛ سپس تصویر آن را از ویرایش پلن آپلود کنید.</Typography>}
    {error && <Alert severity="error">{error}</Alert>}
  </Box>;
}
